/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-28
 */

import { Component, OnInit,ElementRef,Input, AfterViewInit,EventEmitter, Output } from '@angular/core';
import { ControlBaseComponent } from 'src/refresh/form-control/control-base.component';
import { LayoutBaseComponent } from 'src/refresh/layout/layout-base.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.less']
})
export class ErrorsComponent extends LayoutBaseComponent implements OnInit,AfterViewInit {

      constructor( private elRef:ElementRef) { 
            super();
      }

      @Input('error-list')  errorList = [];
      @Input('error-param') errorParam:any;

      @Input ("if")   errorWhere: any;

      public _error:string;
      public _isBool:boolean = false;

      get  error():string {
           return this._error;
      }

      @Input ("error") set error( theValue: string) {

             if ( theValue ) {

                 if( typeof theValue == "boolean" ) {
                     this._isBool = true;
                     this._error = theValue;
                     return;
                 }
                 if ( this.errorWhere !== undefined  ) {

                       if ( typeof this.errorWhere  == 'string' ) {
                            if ( this.errorWhere ) theValue += this.errorWhere
                       }
                       else
                       if ( this.errorWhere )  theValue += "Y";
                       else                    theValue += "N";
                 }
             }

             this._error = theValue;

             if ( environment.production == false )  this.errorCode = theValue;
      }

      public errorCode:string;

      public get className():string {
             return "input-error "+ ControlBaseComponent.errorClassByLang + this.class_name;
      }

      public get inputClass():string {
             return this.input_class;
      }

      public get labelClass():string {
             return this.label_class;
      }

      public ngOnInit(): void {

             if ( this.errorParam && this.errorParam.length >= 0  ) {
                  if ( this.errorParam.charAt(0) == '{' ) {
                       this.errorParam = eval("("+this.errorParam+")");
                  }
             }           
      }
      
      public ngAfterViewInit() {
             let div = this.elRef.nativeElement.querySelector('div');
             super.layoutFromViewInit(div);             
      }
}
